export default __webpack_public_path__ + "static/media/logo-dark.21b11c77.svg";